export const vimeoVideos = [
  { name: "Meditar", id: "569173804" },
  { name: "Ayurveda", id: "569173924" },
  { name: "Próstata", id: "569173657" },
  { name: "Película", id: "569081328" },
];
